import { giphyDarkGrey } from '@giphy/colors'
import styled, { keyframes } from 'styled-components'
import { Slider } from 'ui'
import { Subheading } from '../../style'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 20px;
`

export const Control = styled.div`
    align-items: center;
    animation: ${fadeIn} 0.15s ease-out;
    display: flex;
    grid-column: 2 / 6;
    padding: 0 30px;
`

export const ControlLabel = styled(Subheading)`
    flex-shrink: 0;
    margin: 0;
`

export const ControlSlider = styled(Slider)`
    margin: 0 15px;
    width: 100%;
`

export const ControlValue = styled.div`
    background: ${giphyDarkGrey};
    border-radius: 2px;
    box-sizing: border-box;
    color: #fff;
    flex-shrink: 0;
    font-size: 15px;
    padding: 6px 0;
    text-align: center;
    width: 48px;
`
